.imsImage {
  max-width: 100%;
  margin: 8px 0;
}
